// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone {
  position: relative;
  height: 345px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}
.dropzone label {
  color: #1F2937 !important;
}
.dropzone label u {
  text-decoration: underline;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.close-button {
  color: black;
  border: 1px solid black;
  background-color: white;
  gap: 24px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #ECF0F5;
  gap: 24px;
}

.p-button.button-sm {
  font-size: 12px;
  padding: 10px 12px;
  width: auto;
  height: 32px;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/e-soc/others-upload/othersUpload.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AACJ;AACE;EACE,yBAAA;AACJ;AAAI;EACE,0BAAA;AAEN;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AACF;;AACA;EACE,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAEF;;AAAA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AAGF;;AADA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAIF;;AAFA;EACE,cAAA;EACA,UAAA;EACA,qBAAA;AAKF","sourcesContent":[".dropzone {\n  position: relative;\n  height: 345px;\n  width: 100%;\n  border: 2px dashed #D1D5DB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  // background: url(../../assets/images/fileupload.svg) no-repeat center center;\n  input{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n  }\n  label{\n    color: #1F2937 !important;\n    u{\n      text-decoration: underline;\n    }\n  }\n}\n.fileupload-info{\n  background:#f6f8ff;\n  padding: 15px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.close-button {\n  color: black;\n  border: 1px solid black;\n  background-color: white;\n  gap: 24px;\n}\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid #ECF0F5;\n  gap: 24px;\n}\n.p-button.button-sm{\n  font-size: 12px;\n  padding: 10px 12px;\n  width: auto;\n  height: 32px;\n}\n.fileupload-text{\n  display: block;\n  width: 85%;\n  word-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
